import {select} from "bukku/shared/SagaService";
import _ from "underscore";
import { READ_PRODUCT_DETAIL_LIST_LIMIT, getProductDetailList } from "../List/productDetaiListHelper";
import Big from "big.js";
// import { Float } from "../Transaction/calculation/helper";
import { readLists } from "../Transaction/initTransaction/helper/readLists";
import { L } from "../List/reducer";

export function* readProductDetailsByChunks(productIds, type = 'SALE') {
    const productIdsChunk = _.chunk(productIds, READ_PRODUCT_DETAIL_LIST_LIMIT);
    const list = [];
    for (let i = 0; i < productIdsChunk.length; i += 1) {
        const idsChunk = productIdsChunk[i];
        const productDetailList = yield getProductDetailList(idsChunk, type);
        list.push(productDetailList);
    }

    return list.flat();
}

export function* getBundleItemsDetail() {
    const bundle = yield select(state => state.ProductBundle.bundle);

    yield readLists([L.product_list]);
    const productList = yield select(state => state.List.productList);

    // 1. Get all product IDs
    const productIds = [];
    bundle.items.forEach(item => {
        // skip if it's bundle_discount row as it won't have product_id
        if (item.product_id)
            productIds.push(item.product_id);
    });

    // 2. Remove duplicate IDs
    const uniqueProductIds = [...new Set(productIds)];

    // 3. Filter IDs to be read. Only read from SALE/PURCHASE endpoint if they're is_selling/is_buying.
    const saleProductIds = uniqueProductIds.filter(id => {
        const product = productList.find(p => p.id === id);
        return product?.is_selling;
    });

    const purchaseProductIds = uniqueProductIds.filter(id => {
        const product = productList.find(p => p.id === id);
        return product?.is_buying;
    });

    // 4. Read product details by chunks (max 50 ids per chunk/call)
    const saleProductDetailList = yield readProductDetailsByChunks(saleProductIds, 'SALE');
    const purchaseProductDetailList = yield readProductDetailsByChunks(purchaseProductIds, 'PURCHASE');

    // 5. Find unit price and calculate amounts
    const items = [...bundle.items];

    items.forEach((bundleItem, idx) => {
        const productQtyB = new Big(bundleItem.quantity || 0);

        // a. Find product detail for Sale and Purchase
        const saleProductDetail = saleProductDetailList.find(p => bundleItem.product_id === p.id);
        const purchaseProductDetail = purchaseProductDetailList.find(p => bundleItem.product_id === p.id);

        // b. Find the corresponding product unit
        const saleProductUnit =
            saleProductDetail?.units?.find(unit => unit.id === bundleItem.product_unit_id);
        const purchaseProductUnit =
            purchaseProductDetail?.units?.find(unit => unit.id === bundleItem.product_unit_id);

        // c. Find the product unit price
        const saleProductUnitPriceB = new Big(saleProductUnit?.unit_price || 0);
        const purchaseProductUnitPriceB = new Big(purchaseProductUnit?.unit_price || 0);

        // d. Set the unit price and amount
        // items[idx].sale_unit_price = Float(saleProductUnitPriceB);
        // items[idx].sale_amount = Float(saleProductUnitPriceB.times(productQtyB));

        // items[idx].purchase_unit_price = Float(purchaseProductUnitPriceB);
        // items[idx].purchase_amount = Float(purchaseProductUnitPriceB.times(productQtyB));

        items[idx].sale_unit_price = saleProductUnitPriceB.round(4).toNumber();
        items[idx].sale_amount = saleProductUnitPriceB.times(productQtyB).round(2).toNumber();

        items[idx].purchase_unit_price = purchaseProductUnitPriceB.round(4).toNumber();
        items[idx].purchase_amount = purchaseProductUnitPriceB.times(productQtyB).round(2).toNumber();
    });

    return items;
}
